import axios from 'axios';
import MobileDetect from 'mobile-detect';

export default class AppSettings {


    constructor() {
        AppSettings.instance = this;
        this.templates = {};
        const md = new MobileDetect(window.navigator.userAgent);
        AppSettings.isMobile = md.mobile() != null;

    }

    init() {
        return new Promise((resolve, reject) => {
            axios.get(`/static/data.json?${Date.now()}`)
                .then(response => {

                    const tiles = 4;
                    const projects = this.projects = response.data.projects;
                    const chunks = this.chunks = [];
                    let chunk = [];
                    for (let i = 0; i < projects.length; i+= tiles) {

                        // if (i % tiles == 0) {
                        //     chunk = [];
                        //
                        //     chunks.push(chunk);
                        // }
                        // chunk.push(projects[i]);
                        chunk = [ [projects[i], projects[i + 1]], [projects[i + 2], projects[i + 3]]];

                        chunks.push(chunk);
                    }

                    const fill = 2 - chunk.length;
                    for (let i = 0; i < fill; i++) {
                        chunk.push({});
                    }

                    this.data = response.data;

                    const templates = [
                        // {
                        //   name:'contact',
                        //   url:'./static/contact.html'
                        // },
                        // {
                        //   name:'skills',
                        //   url:'./static/skills.html'
                        // }
                    ];

                    this.loadTemplates(templates)
                        .then(() => {
                            resolve();
                        })
                        .catch(() => {
                            reject();
                        });
                })
                .catch(e => {
                    console.log(e);
                    reject();
                });
        });
    }

    getNextProjects(projectLink) {
        const p = this.projects;
        const l = p.length;
        for (let i = 0; i < l; i++) {
            const project = p[i];
            let ret = [];
            const tiles = 4;
            if (project.link == projectLink) {

                let count = tiles;
                if (i < tiles) {
                    let pos = i - count * 0.5;
                    while (count) {
                        if (pos >= 0 && pos != i) {
                            count--;
                            ret.push(p[pos]);
                        }
                        pos++;
                    }
                } else if (i > l - tiles) {

                    let pos = i + count * 0.5;

                    while (count) {
                        if (pos < l && pos != i) {
                            count--;
                            ret.unshift(p[pos]);
                        }
                        pos--;
                    }
                } else {
                    ret = p.slice(i - count * 0.5, i + count * 0.5 +1);
                    ret.splice(2, 1);
                }
                return [[ret[0],ret[1]], [ret[2],ret[3]]];
            }
        }
        return [];
    }

    loadTemplates(list) {
        return new Promise((resolve, reject) => {

            const load = (index) => {

                if (index == list.length) {
                    resolve();
                    return;
                }
                const data = list[index];
                axios.get(data.url)
                    .then(response => {
                        this.templates[data.name] = response.data;
                        load(index + 1);
                    })
                    .catch(error => {
                        console.log(error);
                        reject();
                    });
            };
            load(0);
        });
    }

}
